import { MdFilterList } from 'react-icons/md'

// Add custom styles for dark mode inputs
const darkModeStyles = `
  .dark select {
    background-color: #1f2937 !important;
    color: #ffffff !important;
  }
  .dark select option {
    background-color: #1f2937 !important;
    color: #ffffff !important;
  }
`

function FilterBar({ filterValue, onFilterChange, filterOptions = [], className = '' }) {
  if (filterOptions.length === 0) return null

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Add custom styles for dark mode */}
      <style>{darkModeStyles}</style>

      <div className="relative">
        <select
          value={filterValue}
          onChange={onFilterChange}
          className="appearance-none pl-10 pr-8 py-2 border border-neutral-300 dark:border-neutral-600 rounded-lg bg-white dark:bg-neutral-800 text-neutral-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        >
          {filterOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <MdFilterList className="absolute left-3 top-1/2 transform -translate-y-1/2 text-neutral-400 text-lg" />
      </div>
    </div>
  )
}

export default FilterBar
